import { mapGetters,  mapActions } from "vuex"

const usersMixin =  {
    computed: {
        ...mapGetters({
            getUsers:"users/getUsers",
            getUserForm:"users/getUserForm",
            getNewUser:"users/getNewUser",
            getPerfilUser:"users/getPerfilUser",
            getUserPerfil:"users/getUserPerfil",
            getStatusLabel:"users/getStatusLabel",
            getStatusColor:"users/getStatusColor",
            getPerfil:"users/getPerfil",
            getHeaderUsres:"users/getHeaderUsres",
            getAvatars:"users/getAvatars",
            getLabelsFisica:"users/getLabelsFisica",
            getLabelsJuridica:"users/getLabelsJuridica",
            getHeaderApis:"users/getHeaderApis",
            getApisConsumed:"users/getApisConsumed",
            getBackupUser:"users/getBackupUser",
        }),
       users:{
           get(){
               return this.getUsers
           },
           set(newvalue) {
               this.setUsers(newvalue)
           }
       } ,
       userForm:{
            get(){
                return this.getUserForm
            },
            set(newvalue) {
                this.setUserForm(newvalue)
            }
        },
        userName:{
            get(){
                return this.userForm.firstName

            },
            set(newValue) {
                this.setUserNameForm(newValue)
            }
        },
        userlastName:{
            get(){
                return this.userForm.lastName

            },
            set(newValue) {
                this.setUserLastNameForm(newValue)
            }
        },
        userPhone:{
            get(){
                return this.userForm.phone

            },
            set(newValue) {
                this.setUserPhoneForm(newValue)
            }
        },
        userCpf:{
            get(){
                return this.userForm.cpf
            },
            set(newValue) {
                this.setUserCpfForm(newValue)
            }
        },
        userCnpj:{
            get(){
                return this.userForm.cnpj
            },
            set(newValue) {
                this.setUserCnpjForm(newValue)
            }
        },
        userCorporateName:{
            get(){
                return this.userForm.corporateName
            },
            set(newValue) {
                this.setUserCorporateNameForm(newValue)
            }
        },
        userFantasyName:{
            get(){
                return this.userForm.fantasyName
            },
            set(newValue) {
                this.setUserFantasyNameForm(newValue)
            }
        },
        userEmail:{
            get(){
                return this.userForm.email
            },
            set(newValue) {
                this.setUserEmailForm(newValue)
            }
        },
        userPerfil:{
            get(){
                return this.userForm.role

            },
            set(newValue) {
                this.setUserPerfilForm(newValue)
            }
        },
        userStatus:{
            get(){
                return this.userForm.status
            },
            set(newValue) {
                this.setUserStatusForm(newValue)
            }
        }  
       
    },
    methods: {
        ...mapActions({
            setUsers:"users/setUsers",
            setUserPerfil: "users/setUserPerfil",
            setUserForm: "users/setUserForm",
            setUserStatusForm:"users/setUserStatusForm",
            setUserPerfilForm:"users/setUserPerfilForm",
            setUserEmailForm:"users/setUserEmailForm",
            setUserPhoneForm:"users/setUserPhoneForm",
            setUserCpfForm:"users/setUserCpfForm",
            setUserCnpjForm:"users/setUserCnpjForm",
            setUserCorporateNameForm:"users/setUserCorporateNameForm",
            setUserFantasyNameForm:"users/setUserFantasyNameForm",
            setUserLastNameForm:"users/setUserLastNameForm",
            setUserNameForm:"users/setUserNameForm",
            setApisConsumed:"users/setApisConsumed",
            setBackupUser:"users/setBackupUser",
            setUserStatus:"users/setUserStatus"
        }),
        allowOnlyLetters(event){
            if ((event.type == 'keydown' && /^[a-zéã'\s]+$/igm.test(event.key)) ||
                (event.type == 'paste' && /^[a-zéã'\s]+$/igm.test(event.clipboardData.getData('text')))) {
                clearTimeout(timer);
                this.nameHint = "";
                return event.key;
            }
            event.preventDefault();
            this.nameHint = "Apenas letras são permitidas neste campo.";
            const timer = setTimeout(() => {this.nameHint = ""}, 3000);
        },
        allowOnlyNumbers(event){
            if(/[A-Z0-9\b\0 ]/.test(event.key)) {
                clearTimeout(timer);
                this.phoneHint = "";
                return event.key;
            }
            event.preventDefault();
            this.phoneHint = "Apenas números são permitidos neste campo.";
            const timer = setTimeout(() => {this.phoneHint = ""}, 3000);
        },
        returnOnlyNumbers(number) {
            const normalizedNumber = number.replace(/\D/g, '');
            return normalizedNumber
        },
        setCnpjMask(number) {
            return number
            .replace(/\D+/g, '')
            .replace(/(\d{2})(\d)/, '$1.$2') 
            .replace(/(\d{3})(\d)/, '$1.$2')
            .replace(/(\d{3})(\d)/, '$1/$2') 
            .replace(/(\d{4})(\d)/, '$1-$2')
            .replace(/(-\d{2})\d+?$/, '$1')
        },
        setCPFMask(number) {
            return number
            .replace(/\D+/g, '')
            .replace(/(\d{3})(\d)/, '$1.$2')
            .replace(/(\d{3})(\d)/, '$1.$2')
            .replace(/(\d{3})(\d)/, '$1-$2')
        },
        formatDate(dateString) {
            if (!dateString) return null
            const [year, month, day] = dateString.split('-')
            return `${day}/${month}/${year}`
        },
    }
}

export default usersMixin;